<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.users')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userParams.login"
                  value="userParams.login"
                  :label="$t('forms.inputs.login')"
                >
                </va-input>
              </div>

              <div class="flex md6 sm6 xs12">
                <va-input
                  v-model="userParams.email"
                  value="userParams.email"
                  :label="$t('forms.inputs.email')"
                >
                </va-input>
              </div>
              <div class="flex md2 sm6 xs12">
                <va-toggle
                  v-model="userParams.active"
                  value="userParams.active"
                  label="Ativo"
                  :color="$themes.secondary"
                  small
                />
              </div>
            </div>

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userParams.password"
                  value="userParams.password"
                  type="password"
                  :label="$t('forms.inputs.password')"
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userParams.re_password"
                  value="userParams.re_password"
                  type="password"
                  :label="$t('forms.inputs.repeatPassword')"
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                 <va-select
                  :label="$t('forms.inputs.timezone')"
                  v-model="userParams.timezone"
                  textBy="name"
                  keyBy="timezone"
                  :options="timezones"
                  searchable
                />
              </div>


            </div> <!-- end row -->

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userParams.name"
                  value="userParams.name"
                  :label="$t('forms.inputs.name')"
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userParams.cpf"
                  value="userParams.cpf"
                  :label="$t('forms.inputs.cpf')"
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.inputs.language')"
                  v-model="userParams.locale"
                  textBy="name"
                  keyBy="code"
                  :options="locales"
                  searchable
                />
              </div>
            </div> <!-- fim row -->

            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  v-if="userParams.userId == ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="create(userParams)"
                >
                  {{ $t('menu.save') }}
                </va-button>
                <va-button
                  v-else
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="update(userParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>
              </div>

              <div class="flex md3 sm6 xs12">
                <va-button
                  v-if="userParams.userId == ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="createSaveNew(userParams)"
                >
                  {{ $t('menu.saveNew') }}
                </va-button>
              </div>

                <div class="flex md2 sm6 xs12">
                  <va-button
                    medium
                    inline
                    color="#ff842b"
                    icon="fa fa-chevron-left"
                    class="ma-0"
                    :to="{ name: 'users', params: {
                      current_page: this.$route.params.current_page,
                      searchName: this.$route.params.searchName,
                      perPage: this.$route.params.perPage }
                      }"
                  >
                    {{ $t('menu.back') }}
                  </va-button>
                </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import UserAPI from '@/services/UserAPI'
import RoleAPI from '@/services/RoleAPI'
import UserRoleAPI from '@/services/UserRoleAPI'
import { showError } from '@/global'

export default {
  name: 'form-user',
  data () {
    return {
      userParams: {
        userId: '',
        login: '',
        password: '',
        name: '',
        cpf: '',
        email: '',
        timezone: '',
        role: [],
        locale: '',
        active: '',
      },
      roles: [],
      timezones: [],
      locales: [
        {
          code: 'en',
          name: 'Inglês',
        },
        {
          code: 'es',
          name: 'Espanhol',
        },
        {
          code: 'pt-BR',
          name: 'Português Brasil',
        },
      ]
    }
  },
  mounted () {
    if (this.$route.params.id != undefined) {
      UserAPI.getUserById(this.$route.params.id).then(response => {
        this.userParams = response.data.user
      })
    }

    RoleAPI.getAllRoles().then(response => {
      this.roles = response.data.roles
    })

    UserAPI.getTimeZones().then(response => {
      this.timezones = response.data.timezones
    })
  },
  methods: {
    create (userParams) {
      if (userParams.password != userParams.re_password) {
        this.showToast(`A senhas não são iguais.`, {
          icon: 'thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      } else {
          this.userParams.timezone = this.userParams.timezone.timezone
          UserAPI.createUser(userParams).then(response => {
            let userId = response.data.id;
            let userRoles = userParams.role;

            userRoles.forEach(function (item)  {
              UserRoleAPI.createRole(userId, item.id).then(response => {
              });
            })

            this.showToast(response.data.message, {
              icon: 'fa-thumbs-o-up',
              position: 'top-right',
              duration: 5000,
            }),

            this.$router.push('/admin/tables/users')
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        });
      }
    },
    createSaveNew (userParams) {
      if (userParams.password != userParams.re_password) {
        this.showToast(`A senhas não são iguais.`, {
          icon: 'thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      } else {
      this.userParams.timezone = this.userParams.timezone.timezone
      UserAPI.createUser(userParams).then(response => {
        let userId = response.data.id;
        let userRoles = userParams.role;

        userRoles.forEach(function (item)  {
          UserRoleAPI.createRole(userId, item.id).then(response => {
          });
        })

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),
        this.userParams.login = ""
        this.userParams.password = ""
        this.userParams.name = ""
        this.userParams.cpf = ""
        this.userParams.email = ""
        this.userParams.timezone = ""
        this.userParams.locale.code = ""
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        });
      }
    },
    update (userParams) {
      if (userParams.password != userParams.re_password) {
        this.showToast(`A senhas não são iguais.`, {
          icon: 'thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      } else {
        this.userParams.timezone = this.userParams.timezone.timezone
        UserAPI.updateUser(userParams).then(response => {
          this.data = response.data;

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          }),

          this.$router.push('/admin/tables/users')
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        });
      }
    }
  }
}
</script>
